import React, { useEffect, useState } from "react";
import {
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan, faTimes } from "@fortawesome/free-solid-svg-icons";
import "../shared/BrandModal.css";

export const RejectModal = (props) => {
  const [reason, setReason] = useState("");
  const [showAdditionalError, setShowAdditionalError] = useState(false);

  const toggle = () => {
    props.setToggle(!props.toggle);
  };

  const submitted = async (e) => {
    e.preventDefault();

    let validated = validate();

    if (!validated) {
      return;
    }

    toggle();
    props.onReject(props.requestId, reason);
  };

  const validate = () => {
    let isSuccess = true;

    if (!reason) {
      setShowAdditionalError(true);
      isSuccess = false;
    }

    return isSuccess;
  };

  return (
    <Modal isOpen={props.toggle} toggle={toggle} size="lg" className="brand-modal">
      <ModalHeader toggle={toggle}>Reject Request</ModalHeader>
      <ModalBody>
        <p className="brand-modal__desc">
          Please provide a reason for rejecting this request.
        </p>
        <Form onSubmit={submitted}>
          <FormGroup>
            <Label for="reason">Reason</Label>
            <Input
              type="textarea"
              name="reason"
              id="reason"
              placeholder="Reason text that will be included in email"
              onChange={(e) => setReason(e.target?.value)}
              value={reason}
            />
            {showAdditionalError && <p className="text-danger">Required</p>}
          </FormGroup>

          <div className="brand-modal__actions">
            <button type="submit" className="brand-modal__btn brand-modal__btn--danger">
              <FontAwesomeIcon icon={faBan} /> Reject
            </button>
            <button type="button" className="brand-modal__btn brand-modal__btn--cancel" onClick={() => toggle()}>
              <FontAwesomeIcon icon={faTimes} /> Cancel
            </button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};
